/**
 * Xano backend configuration.
 *
 * Core APIs (auth, projects, models, etc.) always point at Playground where
 * the live data lives. Only API_EXPORT can be toggled between workspaces.
 */

export const XANO_BASE = "https://x1hz-knoc-qcpv.e2.xano.io";

/**
 * Realtime WebSocket: `wss://<host>/rt/<this>`. Workspace is chosen here, not by `API_*` URLs.
 * Playground connection hash (Realtime settings). Other workspaces use different hashes — keep in sync if you ever point the app at a clone (e.g. v2).
 */
export const XANO_REALTIME_CONNECTION_HASH = "dFeg0QJY6dJOp0URAEnSIc4LRKU";

/** Xano realtime trigger name on channel `project` (message action). Must match workspace trigger. */
export const XANO_REALTIME_TRIGGER_TYPE = "updateFunction";


// ── Core APIs — always Playground (production data lives here) ───────────────
export const API_DEFAULT = `${XANO_BASE}/api:aIaNUgG7`;
export const API_AUTH = `${XANO_BASE}/api:Ys-isoaj`;
export const API_ASSETS = `${XANO_BASE}/api:a_vAWL9X`;
export const API_STRIPE = `${XANO_BASE}/api:UQuTJ3vx`;
export const API_LIBRARY = `${XANO_BASE}/api:Xu_TAyFO`;

// Export endpoint lives under the Default API group at /export/...
export const API_EXPORT = API_DEFAULT;

// Public MCP endpoint users can connect to from AI tools.
export const XANO_MCP_SSE = `${XANO_BASE}/x2/mcp/eV51SQzL/mcp/sse`;
// MCP token management endpoints.
// "User MCP Read" API group (created in Playground workspace).
export const API_USER_MCP_READ = `${XANO_BASE}/api:hwDMQTPm`;

export const API_MCP_TOKEN_STATUS = `${API_USER_MCP_READ}/mcp/token/status`;
export const API_MCP_TOKEN = `${API_USER_MCP_READ}/mcp/token`;
